// JavaScript Document


jQuery(document).ready(function () {

  function scrollToAnchor(aid) {
    var aTag = $("a[name='" + aid + "']");
    //$('html,body').animate({scrollTop: aTag.offset().top},'slow');

    jQuery("html, body").animate({
      scrollTop: jQuery(document).height()
    }, "slow");
    return false;
  }
  /***** sliders ****/


  jQuery('.banner_slider').owlCarousel({
    loop: true,
    autoplay: true,
    nav: true,
    navText: ["", ""],
    dots: true,
	responsiveRefreshRate: 1,
    responsiveBaseWidth: window,
    responsive: {
      320: {
        items: 1
      },
      480: {
        items: 1
      },
      768: {
        items: 1
      }
    }
  });

  jQuery('.slider2_resp').owlCarousel({
    loop: true,
    autoplay: true,
    nav: false,
    navText: ["", ""],
    dots: true,
	responsiveRefreshRate: 1,
    responsiveBaseWidth: window,
    responsive: {
      320: {
        items: 1
      },
      480: {
        items: 1
      },
      768: {
        items: 1
      }
    }
  });


  /**** control revealdown ****/

  jQuery(".mas_info").click(function (event) {
    event.preventDefault();
    jQuery("html, body").animate({
      scrollTop: (jQuery(jQuery(this).attr("href")).offset().top - 400)
    }, 500);

  });

  jQuery(".close_link").click(function (event) {
    event.preventDefault();
    jQuery("html, body").animate({
      scrollTop: (jQuery(jQuery(this).attr("href")).offset().top - 10)
    }, 500);

  });
	
	
	jQuery("#productos_estrella .close-roll a").click(function (event) {
    event.preventDefault();
    /*jQuery("html, body").animate({
      scrollTop: (jQuery(jQuery(this).attr("href")).offset().top - 10)
    }, 500);*/

  });

  jQuery("#productos_estrella .close-roll-responsive a").click(function (event) {
    event.preventDefault();
    /*jQuery("html, body").animate({
      scrollTop: (jQuery(jQuery(this).attr("href")).offset().top - 10)
    }, 500);*/

  });
  /* liebherr */
	
	
  jQuery(".reveal_down").click(function (event) {
    event.preventDefault();
    jQuery("html, body").animate({
      scrollTop: (jQuery(jQuery(this).attr("href")).offset().top - 400)
    }, 500);

  });

  jQuery(".desplegable_gamas .close_link").click(function (event) {
    event.preventDefault();
    jQuery("html, body").animate({
      scrollTop: (jQuery(jQuery(this).attr("href")).offset().top - 1000)
    }, 500);

  });

  /* end liebherr */
	
/*** coldtainer ***/
	jQuery(".txt_descargar .mas_info").click(function (event) {
    	event.preventDefault();
	});
	
/****/	

  /********************************/

  checkDesktop = window.matchMedia('(min-width: 980px)');
  checkTablet = window.matchMedia('(min-width: 768px) and (max-width: 979px)');
  checkMobile = window.matchMedia('(max-width: 767px)');
  checkMobileS = window.matchMedia('(max-width: 440px)');


  if (checkMobileS.matches) {
    jQuery("#naboo .mas_info").click(function () {
      jQuery("#naboo").animate({
        height: 2715
      }, 700);
    });

    jQuery("#naboo .close_link").click(function () {
      jQuery("#naboo").animate({
        height: 850
      }, 700);
    });

    jQuery("#naboo_opti .mas_info").click(function () {

      jQuery("#naboo_opti").animate({
        height: 2730
      }, 700);
    })

    jQuery("#naboo_opti .close_link").click(function () {
      jQuery("#naboo_opti").animate({
        height: 808
      }, 700);
    });

    jQuery("#oracle .mas_info").click(function () {
      jQuery("#oracle").animate({
        height: 3645
      }, 700);
    });

    jQuery("#oracle .close_link").click(function () {
      jQuery("#oracle").animate({
        height: 1006
      }, 700);
    });

    jQuery("#seccion_gamas .gamas_lib .items_gamas_lib_1").click(function () {

      jQuery("#seccion_gamas").animate({
        height: 4126
      }, 700);
      jQuery(".gtab").css('opacity', '1');
      jQuery(".gtab").css('margin-top', '-45px');
      jQuery("#desplegable_gamas1").css('opacity', '1');
      jQuery("#desplegable_gamas2").css('opacity', '0');
      jQuery("#desplegable_gamas3").css('opacity', '0');
      jQuery("#seccion_gamas .gamas_lib .items_gamas_lib_1").css('z-index', '0');
	  jQuery("#seccion_gamas .gamas_lib .items_gamas_lib_2").css('z-index', '0');
	  jQuery("#seccion_gamas .gamas_lib .items_gamas_lib_3").css('z-index', '0');



      /*jQuery("#desplegable_gamas2").css('opacity', '0');*/
    });

    jQuery("#seccion_gamas .gamas_lib .items_gamas_lib_2").click(function () {
      jQuery("#seccion_gamas").animate({
        height: 4268
      }, 700);
      jQuery(".gtab").css('opacity', '1');
      jQuery(".gtab").css('margin-top', '-45px');
      jQuery("#desplegable_gamas2").css('opacity', '1');
      jQuery("#desplegable_gamas1").css('opacity', '0');
      jQuery("#desplegable_gamas3").css('opacity', '0');
      jQuery("#seccion_gamas .gamas_lib .items_gamas_lib_2").css('z-index', '0');
		jQuery("#seccion_gamas .gamas_lib .items_gamas_lib_1").css('z-index', '1');
		      jQuery("#seccion_gamas .gamas_lib .items_gamas_lib_3").css('z-index', '0');

      /*jQuery("#desplegable_gamas2").css('opacity', '0');*/
    });

    jQuery("#seccion_gamas .gamas_lib .items_gamas_lib_3").click(function () {
      jQuery("#seccion_gamas").animate({
        height: 5395
      }, 700);
      jQuery(".gtab").css('opacity', '1');
      jQuery(".gtab").css('margin-top', '-45px');
      jQuery("#desplegable_gamas3").css('opacity', '1');
      jQuery("#desplegable_gamas2").css('opacity', '0');
      jQuery("#desplegable_gamas1").css('opacity', '0');
      jQuery("#seccion_gamas .gamas_lib .items_gamas_lib_2").css('z-index', '1');
      jQuery("#seccion_gamas .gamas_lib .items_gamas_lib_3").css('z-index', '0');

      /*jQuery("#desplegable_gamas2").css('opacity', '0');*/
    });

    jQuery("#desplegable_gamas3 .close_link, #desplegable_gamas2 .close_link, #desplegable_gamas1 .close_link").click(function () {
      jQuery("#seccion_gamas").animate({
        height: 2220
      }, 700);
      /*jQuery('.items_gamas_lib a').removeClass("active");*/
      jQuery(".gtab").css('opacity', '0');
      jQuery(".gtab").css('margin-top', '0px');
      jQuery("#desplegable_gamas3").css('opacity', '0');
      jQuery("#desplegable_gamas2").css('opacity', '0');
      jQuery("#desplegable_gamas1").css('opacity', '0');
      jQuery(".items_gamas_lib").css('z-index', '1')

    });
	  

  } else if (checkMobile.matches) {
    /*alert("767");*/
    /*jQuery(window).trigger('mobile');*/
    jQuery("#naboo .mas_info").click(function () {
      jQuery("#naboo").animate({
        height: 2717
      }, 700);

    });

    jQuery("#naboo .close_link").click(function () {
      jQuery("#naboo").animate({
        height: 600
      }, 700);
    });

    jQuery("#naboo_opti .mas_info").click(function () {

      jQuery("#naboo_opti").animate({
        height: 1250
      }, 700);
    })

    jQuery("#naboo_opti .close_link").click(function () {
      jQuery("#naboo_opti").animate({
        height: 700
      }, 700);
    });

    jQuery("#oracle .mas_info").click(function () {
      scrollToAnchor('oracle_extended');
      jQuery("#oracle").animate({
        height: 2250
      }, 700);
    });

    jQuery("#oracle .close_link").click(function () {
      jQuery("#oracle").animate({
        height: 900
      }, 700);
    });


    jQuery("#seccion_gamas .gamas_lib .items_gamas_lib_1").click(function () {

      jQuery("#seccion_gamas").animate({
        height: 4165
      }, 700);
      jQuery(".gtab").css('opacity', '1');
      jQuery(".gtab").css('margin-top', '-45px');
      jQuery("#desplegable_gamas1").css('opacity', '1');
      jQuery("#desplegable_gamas2").css('opacity', '0');
      jQuery("#desplegable_gamas3").css('opacity', '0');
      jQuery("#seccion_gamas .gamas_lib .items_gamas_lib_1").css('z-index', '0');
				      jQuery("#seccion_gamas .gamas_lib .items_gamas_lib_2").css('z-index', '0');


      /*jQuery("#desplegable_gamas2").css('opacity', '0');*/
    });

    jQuery("#seccion_gamas .gamas_lib .items_gamas_lib_2").click(function () {
      jQuery("#seccion_gamas").animate({
        height: 4268
      }, 700);
      jQuery(".gtab").css('opacity', '1');
      jQuery(".gtab").css('margin-top', '-45px');
      jQuery("#desplegable_gamas2").css('opacity', '1');
      jQuery("#desplegable_gamas1").css('opacity', '0');
      jQuery("#desplegable_gamas3").css('opacity', '0');
 jQuery("#seccion_gamas .gamas_lib .items_gamas_lib_2").css('z-index', '0');
		jQuery("#seccion_gamas .gamas_lib .items_gamas_lib_1").css('z-index', '1');
		      jQuery("#seccion_gamas .gamas_lib .items_gamas_lib_3").css('z-index', '0');
      /*jQuery("#desplegable_gamas2").css('opacity', '0');*/
    });

    jQuery("#seccion_gamas .gamas_lib .items_gamas_lib_3").click(function () {
      jQuery("#seccion_gamas").animate({
        height: 4741
      }, 700);
      jQuery(".gtab").css('opacity', '1');
      jQuery(".gtab").css('margin-top', '-45px');
      jQuery("#desplegable_gamas3").css('opacity', '1');
      jQuery("#desplegable_gamas2").css('opacity', '0');
      jQuery("#desplegable_gamas1").css('opacity', '0');
      //jQuery(".items_gamas_lib").css('z-index', '0');
 jQuery("#seccion_gamas .gamas_lib .items_gamas_lib_2").css('z-index', '1');
      jQuery("#seccion_gamas .gamas_lib .items_gamas_lib_3").css('z-index', '0');
      /*jQuery("#desplegable_gamas2").css('opacity', '0');*/
    });

    jQuery("#desplegable_gamas3 .close_link, #desplegable_gamas2 .close_link, #desplegable_gamas1 .close_link").click(function () {
      jQuery("#seccion_gamas").animate({
        height: 4741
      }, 700);
      /*jQuery('.items_gamas_lib a').removeClass("active");*/
      jQuery(".gtab").css('opacity', '0');
      jQuery(".gtab").css('margin-top', '0px');
      jQuery("#desplegable_gamas3").css('opacity', '0');
      jQuery("#desplegable_gamas2").css('opacity', '0');
      jQuery("#desplegable_gamas1").css('opacity', '0');
      jQuery(".items_gamas_lib").css('z-index', '1');

    });

  } else if (checkTablet.matches) {
    /* jQuery(window).trigger('tablet');*/
    //alert("tablet");
    jQuery("#naboo .mas_info").click(function () {
      jQuery("#naboo").animate({
        height: 1250
      }, 700);

    });

    jQuery("#naboo .close_link").click(function () {
      jQuery("#naboo").animate({
        height: 562
      }, 700);
    });

    jQuery("#naboo_opti .mas_info").click(function () {

      jQuery("#naboo_opti").animate({
        height: 1250
      }, 700);
    })

    jQuery("#naboo_opti .close_link").click(function () {
      jQuery("#naboo_opti").animate({
        height: 700
      }, 700);
    });

    jQuery("#oracle .mas_info").click(function () {
      jQuery("#oracle").animate({
        height: 2592
      }, 700);
    });

    jQuery("#oracle .close_link").click(function () {
      jQuery("#oracle").animate({
        height: 1006
      }, 700);
    });


    /* liebherr */
    jQuery("#seccion_gamas .gamas_lib .items_gamas_lib_1").click(function () {
      jQuery("#seccion_gamas").animate({
        height: 2166
      }, 700);
      jQuery(".gtab").css('opacity', '1');
      jQuery(".gtab").css('margin-top', '-45px');
      jQuery("#desplegable_gamas1").css('opacity', '1');
      jQuery("#desplegable_gamas2").css('opacity', '0');
      jQuery("#desplegable_gamas3").css('opacity', '0');
      /*jQuery("#desplegable_gamas2").css('opacity', '0');*/
    });

    jQuery("#seccion_gamas .gamas_lib .items_gamas_lib_2").click(function () {
      jQuery("#seccion_gamas").animate({
        height: 2001
      }, 700);
      jQuery(".gtab").css('opacity', '1');
      jQuery(".gtab").css('margin-top', '-45px');
      jQuery("#desplegable_gamas2").css('opacity', '1');
      jQuery("#desplegable_gamas1").css('opacity', '0');
      jQuery("#desplegable_gamas3").css('opacity', '0');
      /*jQuery("#desplegable_gamas2").css('opacity', '0');*/
    });

    jQuery("#seccion_gamas .gamas_lib .items_gamas_lib_3").click(function () {
      jQuery("#seccion_gamas").animate({
        height: 2196
      }, 700);
      jQuery(".gtab").css('opacity', '1');
      jQuery(".gtab").css('margin-top', '-45px');
      jQuery("#desplegable_gamas3").css('opacity', '1');
      jQuery("#desplegable_gamas2").css('opacity', '0');
      jQuery("#desplegable_gamas1").css('opacity', '0');
      /*jQuery("#desplegable_gamas2").css('opacity', '0');*/
    });

    jQuery("#desplegable_gamas3 .close_link, #desplegable_gamas2 .close_link, #desplegable_gamas1 .close_link").click(function () {
      jQuery("#seccion_gamas").animate({
        height: 800
      }, 700);
      /*jQuery('.items_gamas_lib a').removeClass("active");*/
      jQuery(".gtab").css('opacity', '0');
      jQuery(".gtab").css('margin-top', '0px');
    });
  } else {
    console.log('init desk');
    /*jQuery(window).trigger('desktop');*/
    jQuery("#naboo .mas_info").click(function () {
      jQuery("#naboo").animate({
        height: 1400
      }, 700);

    });

    jQuery("#naboo .close_link").click(function () {
      jQuery("#naboo").animate({
        height: 600
      }, 700);
    });

    jQuery("#naboo_opti .mas_info").click(function () {

      jQuery("#naboo_opti").animate({
        height: 1250
      }, 700);
    })

    jQuery("#naboo_opti .close_link").click(function () {
      jQuery("#naboo_opti").animate({
        height: 700
      }, 700);
    });

    jQuery("#oracle .mas_info").click(function () {
      jQuery("#oracle").animate({
        height: 2350
      }, 700);
    });

    jQuery("#oracle .close_link").click(function () {
      jQuery("#oracle").animate({
        height: 1055
      }, 700);
    });

    jQuery("#seccion_gamas .gamas_lib .items_gamas_lib_1").click(function () {
      jQuery("#seccion_gamas").animate({
        height: 2490
      }, 700);
      jQuery(".gtab").css('opacity', '1');
      jQuery(".gtab").css('margin-top', '-45px');
      jQuery("#desplegable_gamas1").css('opacity', '1');
      jQuery("#desplegable_gamas2").css('opacity', '0');
      jQuery("#desplegable_gamas3").css('opacity', '0');
      /*jQuery("#desplegable_gamas2").css('opacity', '0');*/
    });

    jQuery("#seccion_gamas .gamas_lib .items_gamas_lib_2").click(function () {
      jQuery("#seccion_gamas").animate({
        height: 2353
      }, 700);
      jQuery(".gtab").css('opacity', '1');
      jQuery(".gtab").css('margin-top', '-45px');
      jQuery("#desplegable_gamas2").css('opacity', '1');
      jQuery("#desplegable_gamas1").css('opacity', '0');
      jQuery("#desplegable_gamas3").css('opacity', '0');
      /*jQuery("#desplegable_gamas2").css('opacity', '0');*/
    });

    jQuery("#seccion_gamas .gamas_lib .items_gamas_lib_3").click(function () {
      jQuery("#seccion_gamas").animate({
        height: 2455
      }, 700);
      jQuery(".gtab").css('opacity', '1');
      jQuery(".gtab").css('margin-top', '-45px');
      jQuery("#desplegable_gamas3").css('opacity', '1');
      jQuery("#desplegable_gamas2").css('opacity', '0');
      jQuery("#desplegable_gamas1").css('opacity', '0');
      /*jQuery("#desplegable_gamas2").css('opacity', '0');*/
    });

    jQuery("#desplegable_gamas3 .close_link, #desplegable_gamas2 .close_link, #desplegable_gamas1 .close_link").click(function () {
      jQuery("#seccion_gamas").animate({
        height: 800
      }, 700);
      /*jQuery('.items_gamas_lib a').removeClass("active");*/
      jQuery(".gtab").css('opacity', '0');
      jQuery(".gtab").css('margin-top', '0px');
    });
  }
	
	/*** FIREX ***/
	jQuery('#productos_estrella .prod_estrella_container_items .prod_estrella_item_1').click(function () {
		
		jQuery("#productos_estrella .container_seccion_cucimix_click").css({"opacity": "1", "z-index": "1"}).animate({top:80}, 800, function() {});
		jQuery("#productos_estrella .container_seccion_betterpan_click").css('opacity', '0');
		jQuery("#productos_estrella .container_seccion_baskett_click").css('opacity', '0');
	});
	
	jQuery('#productos_estrella .prod_estrella_container_items .prod_estrella_item_2').click(function () {
		jQuery("#productos_estrella .container_seccion_cucimix_click").css('opacity', '0');
		jQuery("#productos_estrella .container_seccion_betterpan_click").css({"opacity": "1", "z-index": "1"}).animate({top:80}, 800, function() {});
		jQuery("#productos_estrella .container_seccion_baskett_click").css('opacity', '0');
	});
		
	
	jQuery('#productos_estrella .prod_estrella_container_items .prod_estrella_item_3').click(function () {
		jQuery("#productos_estrella .container_seccion_cucimix_click").css('opacity', '0');
		jQuery("#productos_estrella .container_seccion_betterpan_click").css('opacity', '0');
		jQuery("#productos_estrella .container_seccion_baskett_click").css({"opacity": "1", "z-index": "1"}).animate({top:80}, 800, function() {});
	});
	
	jQuery('#productos_estrella .container_seccion_cucimix_click .close-roll a, #productos_estrella .container_seccion_betterpan_click .close-roll a , #productos_estrella .container_seccion_baskett_click .close-roll a, #productos_estrella .container_seccion_baskett_click .close-roll-responsive a, #productos_estrella .container_seccion_betterpan_click .close-roll-responsive a, #productos_estrella .container_seccion_cucimix_click .close-roll-responsive a').click(function () {
		console.log('Funciona?');
		if (checkMobileS) {
			jQuery("#productos_estrella .container_seccion_cucimix_click").css({"opacity": "1", "z-index": "1"}).animate({top:1500}, 800, function() {});
		jQuery("#productos_estrella .container_seccion_betterpan_click").css({"opacity": "1", "z-index": "1"}).animate({top:1500}, 800, function() {});
		jQuery("#productos_estrella .container_seccion_baskett_click").css({"opacity": "1", "z-index": "1"}).animate({top:1500}, 800, function() {});
			
			jQuery('#productos_estrella .prod_estrella_container_items .prod_estrella_item_1').click(function () {
				jQuery("html, body").animate({ scrollTop: (jQuery('#productos_estrella').offset().top - 50)}, 100);
			});
			
			jQuery('#productos_estrella .prod_estrella_container_items .prod_estrella_item_2').click(function () {
				jQuery("html, body").animate({ scrollTop: (jQuery('#productos_estrella').offset().top - 50)}, 100);
			});
			
			jQuery('#productos_estrella .prod_estrella_container_items .prod_estrella_item_3').click(function () {
				jQuery("html, body").animate({ scrollTop: (jQuery('#productos_estrella').offset().top - 50)}, 100);
			});
		}
		
		else {
			jQuery("#productos_estrella .container_seccion_cucimix_click").css({"opacity": "1", "z-index": "1"}).animate({top:510}, 800, function() {});
			jQuery("#productos_estrella .container_seccion_betterpan_click").css({"opacity": "1", "z-index": "1"}).animate({top:510}, 800, function() {});
			jQuery("#productos_estrella .container_seccion_baskett_click").css({"opacity": "1", "z-index": "1"}).animate({top:510}, 800, function() {});
		}
	});
	/* END FIREX */
	
	

  jQuery(window).on('desktop', function (e) {


  });


  jQuery(window).on('tablet', function (e) {

  });

  jQuery(window).on('mobiles', function (e) {


  });
});
